import { Component, effect, input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ImportData } from '@xanadu/model';

@Component({
    selector: 'app-import',
    templateUrl: './import.component.html',
    styleUrls: ['./import.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImportComponent {
    formGroup = input<FormGroup>();
    model = input<ImportData>();
    status = input<any>();

    public metaExpansionEndpoint: any = { title: 'Endpoint', description: 'Import endpoint and parameters' };
    public metaExpansionCast: any = { title: 'Cast', description: 'Cast function' };

    public formImport: FormGroup = new FormGroup({});

    constructor() {
        effect(() => {
            const formGroup = this.formGroup();
            const status = this.status();

            if (formGroup && status) {
                formGroup.addControl('_import', this.formImport);
                status.endpoint = status.endpoint || {};
                status.cast = status.cast || {};
            }
        });
    }
}
